import { jsx as o } from "react/jsx-runtime";
import r from "./Button.es.js";
const s = (t) => /* @__PURE__ */ o(r, { ...t, unstyled: !0 });
export {
  s as default
};
//# sourceMappingURL=UnstyledButton.es.js.map
